import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const FoodDeliveryTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { path: "/dashboard/fooddelivery", label: "Overview" },
    { path: "/dashboard/fooddelivery/orders", label: "Orders" },
    { path: "/dashboard/fooddelivery/menu", label: "Menu" },
    { path: "/dashboard/fooddelivery/revenue", label: "Revenue" },
    { path: "/dashboard/fooddelivery/discounts", label: "Discounts" },
    { path: "/dashboard/fooddelivery/staff", label: "Staff" },
    { path: "/dashboard/fooddelivery/order-history", label: "Order History" },
    { path: "/dashboard/fooddelivery/gst-details", label: "GST Details" },
    { path: "/dashboard/fooddelivery/notifications", label: "Send Notification" },
    { path: "/dashboard/fooddelivery/posters", label: "Marketing Poster" },
    { path: "/dashboard/fooddelivery/delivery-price", label: "Delivery Price" },
    { path: "/dashboard/fooddelivery/store-timing", label: "Store Timing" },
  ];

  const isActive = (tabPath) => location.pathname === tabPath;

  return (
    <div className="flex flex-wrap gap-2 border-b border-gray-200 bg-white px-6 py-4">
      {tabs.map((tab) => (
        <button
          key={tab.path}
          onClick={() => navigate(tab.path)}
          className={`px-4 py-2 rounded-lg font-medium text-sm transition-colors ${
            isActive(tab.path)
              ? "bg-gray-900 text-white"
              : "bg-gray-100 text-gray-700 hover:bg-gray-200"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default FoodDeliveryTabs;
